// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__20GsC","questions":"styles_questions__2DkMS","footer":"styles_footer__3qpe9"};